import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CardModule,
  PageActionsModule,
  PageHeaderModule,
  SelectModule,
  SmartModalModule,
  SpinnerModule,
  SmartTableModule,
  IconModule,
  TextInputModule,
} from '@certemy/ui-components';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { canDeactivateGuard } from 'directives/can-deactivate-guard';
import {
  organizationRolesResolver,
  OrganizationRolesService,
  organizationRolesEditPermissionResolver,
  OrganizationRolesEditPermissionResolverService,
} from 'features/organization-settings/organization-roles/organization-roles.service';
import { OrganizationRolesComponent } from 'features/organization-settings/organization-roles/organization-roles.component';
import { NoContentModule } from 'components/no-content/no-content.module';
import { OrganizationRolesModalComponent } from 'features/organization-settings/organization-roles/organization-roles-modal/organization-roles-modal';
import { InlineErrorModule } from 'components/errors/inline-error.module';
import { ActiveCredentialsTableModalComponent } from 'features/organization-settings/organization-roles/active-credentials-table-modal/active-credentials-table-modal';

@NgModule({
  providers: [OrganizationRolesService, OrganizationRolesEditPermissionResolverService],
})
export class OrganizationRolesServiceModule {}

@NgModule({
  imports: [
    CertemyCommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: OrganizationRolesComponent,
        canDeactivate: [canDeactivateGuard],
        resolve: {
          roles: organizationRolesResolver,
          editPermission: organizationRolesEditPermissionResolver,
        },
      },
    ]),
    CardModule,
    PageHeaderModule,
    PageActionsModule,
    SmartModalModule.forRoot(),
    SpinnerModule,
    SelectModule,
    SmartTableModule,
    NoContentModule,
    IconModule,
    TextInputModule,
    InlineErrorModule,
    OrganizationRolesServiceModule,
  ],
  declarations: [OrganizationRolesComponent, OrganizationRolesModalComponent, ActiveCredentialsTableModalComponent],
})
export class OrganizationRolesModule {}
